import { OverlayView } from '@react-google-maps/api';
import { getFootprintColor } from '../../hooks/useFootprints';

/**
 * 色付きのあとSVGアイコン
 * @param {string} color - 16進数カラーコード（例: '#fff' | '#000'）
 */
const FootprintSVGIcon = ({ color = '#fff' }) => (
  <svg viewBox="0 0 62.84 64.9" style={{ width: '100%', height: '100%' }}>
    <g>
      <path fill={color} d="M61.54,9.44c-.33-.05-.73-.01-1.16.12l-12.78,3.75c-1.72.51-2.06,1.95-.76,3.19l1.41,1.34c1.95.78,3.72,2.2,4.69,3.88l.77,1.32,2.76,2.62c.43.41.87.64,1.28.7.85.13,1.58-.45,1.87-1.62l3.12-12.93c.3-1.32-.21-2.22-1.21-2.37Z"/>
      <path fill={color} d="M49.25,23.89c-.67-1.15-2.23-2.15-3.61-2.36-.13-.02-.27-.03-.4-.04l-23.53-.74c-.33,0-.67.04-1,.13-.31.71-.77,1.4-1.36,2.01l-2.45,2.59-9.42,21.03c-.61,1.34-.22,3.25.86,4.24l13.31,12.32c.9.83,2.51,1.54,3.88,1.75.26.04.51.06.75.06h19.71c1.47,0,3.18-1.07,3.84-2.4l8.86-18.16c.65-1.31.57-3.44-.18-4.7l-9.25-15.74Z"/>
      <path fill={color} d="M24.15,15.66c.18.03.36.04.57.03l13.31-.34c1.79-.04,2.5-1.34,1.56-2.87l-6.94-11.35c-.41-.67-.92-1.04-1.44-1.12-.67-.1-1.35.3-1.84,1.19l-6.37,11.69c-.77,1.4-.24,2.55,1.15,2.76Z"/>
      <path fill={color} d="M15.32,16.8l-12.94-3.12c-.1-.02-.2-.04-.29-.05-1.57-.24-2.44.8-1.97,2.43l3.76,12.77c.27.92.8,1.44,1.43,1.54.55.09,1.17-.16,1.75-.77l9.17-9.64c1.24-1.3.82-2.72-.92-3.15Z"/>
    </g>
  </svg>
);

/**
 * 足あとマーカー
 * - SVGアイコンを白色で表示
 * - ピンの背景色は残り時間に応じて変化
 * - FOOTPRINT_ZOOM_THRESHOLD 未満のズームでは非表示（親側で制御）
 */
const FootprintMarker = ({ post, onClick }) => {
  const color = getFootprintColor(post);

  return (
    <OverlayView
      position={post.location}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <div
        onClick={onClick}
        style={{ transform: 'translate(-50%, -100%)', cursor: 'pointer' }}
        aria-label={`${post.nickname}の足あと`}
      >
        {/* SVGアイコン（白色）を色付きピンで囲む */}
        <div
          style={{
            width: post.isSuper ? 40 : 32,
            height: post.isSuper ? 40 : 32,
            backgroundColor: color,
            borderRadius: '50% 50% 50% 0',
            transform: 'rotate(-45deg)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
            border: '2px solid white',
            padding: '4px',
          }}
        >
          <div style={{ transform: 'rotate(45deg)', width: '100%', height: '100%' }}>
            <FootprintSVGIcon color="white" />
          </div>
        </div>
      </div>
    </OverlayView>
  );
};

export default FootprintMarker;